export default __webpack_public_path__ + "static/media/5.db0bac9c.png";